import React from 'react';
import { Typography } from "../../index";
import './message_spinner.scss';

export const MessageSpinner = ({
    message,
    variant = "default"
}) => {

    const messageSpinnerClasses = [
        `mybswh-message-spinner`,
        `mybswh-message-spinner--${variant}`
    ].join(' ');

    return <>
        <div className={messageSpinnerClasses}>
            <div className="maxWidth-content">
                <div className="doubleSpinner">
                    <div className="outerRing" />
                    <div className="innerRing" />
                    <div className="spinner-bg" />
                </div>
                {message &&
                    <div className="mybswh-message-spinner__msg">
                        <Typography
                            type="heading-03"
                            tag="div"
                            textAlign="center"
                            color="$color-secondary-a2"
                            responsive
                        >
                            {message}
                        </Typography>
                    </div>
                }
            </div>
        </div>
    </>;
}